import Label from "@ingka/label";
import { Select, Option } from "@ingka/select";
import FormField from "@ingka/form-field";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  options: Record<string, string>;
  disabled: boolean;
};

const Objective = ({ options, disabled }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const error = getValidationError("objective", activeAsset.id!);
  const isUpdating = isMetadataUpdating(activeAsset.id!, "objective");
  return (
    <>
      <Label
        htmlFor="objective"
        label={
          <LabelWithToolTip
            labelText="Objective"
            toolTipText={`Refers to three different business objectives:
    Activate by engaging people who know IKEA to visit more often, to purchase more and share.
    Attract new customers to shop at IKEA.
    Convert by meeting customers' needs in their journey with relevant information and communication.
    `}
          />
        }
      />
      <FormField
        valid="error"
        validation={{
          msg: error?.message,
          type: "error",
        }}
        shouldValidate={Boolean(error)}
      >
        <Select
          id="objective"
          value={activeAsset.objective || ""}
          disabled={disabled || isUpdating}
          onChange={(e) => {
            updateMetadata({
              objective: e.target.value,
            });
          }}
        >
          {Object.entries(options).map(([name, label]) => (
            <Option key={name} name={label} value={name} />
          ))}
        </Select>
      </FormField>
    </>
  );
};

export default Objective;
